import AppLink from "root/s360components/AppLink";
import {EXTERNAL_icons, S360_urls} from "root/s360components/constants/S360_constants";
import React, {Fragment, useEffect, useState} from "react";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {ADMIN_USER_TYPES} from "root/s360components/AdminUsersDashboard";
import ESchoolsDashboardLink from "root/s360components/ESchoolsDashboardLink";
import {getUserDetails} from "root/DataFunctions/EditUserFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import useModalComponent from "root/s360components/Modals/useModalComponent";
import ModalGoogleAccountProvision from "root/s360components/Modals/GoogleAccountProvision/ModalGoogleAccountProvision";
import ModalGenericMessage from "root/s360components/Modals/GenericMessage/ModalGenericMessage";


/**
 *
 * @uses useAdminUsersDashboardContext
 * @param school_id
 * @param user_id
 * @param user_type
 * @param permissionFlags
 * @returns {JSX.Element}
 * @constructor
 */
const AdminGoogleLinks = ({ school_id, user_id, user_type, permissionFlags}) =>
{

    const [data, setData] = useState({isLoading: true, data: []});

    const [renderModalGoogleAccountProvision, onClickActivateModalGoogleAccountProvision] = useModalComponent(ModalGoogleAccountProvision);

    const [renderModalGenericMessage, onClickActivateModalGenericMessage] = useModalComponent(ModalGenericMessage);

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getUserDetails(user_id, user_type, (response) =>
        {
            const data = getDataFromResponse(response)[0];

            setData({isLoading: false, data: data});
        })
    }

    const onClickTriggerGoogleAccount = () =>
    {
        onClickActivateModalGoogleAccountProvision({user_id: 'current'})
            .then((response) =>
            {
                if (!response) return; // modal cancelled - useModalComponent resolves with null

                const created = response.custom_data?.check?.created;

                const title = created ? 'Google Account Created' : 'Failed to Create Google Account';

                const message = created ? 'You can now use the Google Links to access your Google account features' : response.custom_data?.check?.reason;

                const messageColour = created ? undefined : 'red';

                const subtext = created ? undefined : response.custom_data?.check?.subtext;

                setData({isLoading: true, data: []});
                getData();
                onClickActivateModalGenericMessage({title: title, message: message, messageColour: messageColour, subtext: subtext});
            });
    }

    const shouldShowOnlineSafety = (onlineSafetyEnabled) =>
    {
        const ENABLED = 1;

        return +onlineSafetyEnabled === ENABLED;
    }

    const shouldShowESchools = (eSchoolsEnabled) =>
    {
        const ENABLED = 'Y';

        return eSchoolsEnabled === ENABLED;
    }

    const permissions =
        {
            [ADMIN_USER_TYPES.SCHOOL_ADMIN]:
                {
                    googleDrive: true,
                    googleEmail: true,
                    googleCalendar: true,
                    eSchools: shouldShowESchools(permissionFlags.eschools_admin),
                    onlineSafety: false,
                    discuss: false,
                    sites: false,
                    notes: false
                },
            [ADMIN_USER_TYPES.GOVERNOR]:
                {
                    googleDrive: true,
                    googleEmail: true,
                    googleCalendar: true,
                    eSchools: shouldShowESchools(permissionFlags.eschools_admin),
                    onlineSafety: false,
                    discuss: true,
                    sites: true,
                    notes: true
                },
            [ADMIN_USER_TYPES.TEACHER]:
                {
                    googleDrive: true,
                    googleEmail: true,
                    googleCalendar: true,
                    eSchools: shouldShowESchools(permissionFlags.eschools_admin),
                    onlineSafety: shouldShowOnlineSafety(permissionFlags.online_safety_audit_enabled),
                    discuss: false,
                    sites: false,
                    notes: false
                }
        };

    if(data.isLoading === true)
    {
        return <SpinnerDiv/>
    }

    const hasGoogleAccount = data.data.has_google_account === 1;
    const provisionOnClick = () => onClickTriggerGoogleAccount();

    return (
        <>
            <div className='link-wrapper-external'>
                {permissions[user_type].googleEmail && <AppLink link={hasGoogleAccount ? S360_urls.GMAIL_URL : undefined} target='_blank' title='Mail'
                                                                imageSrc={EXTERNAL_icons.GMAIL} height={'60px'} width={'67px'} onClick={provisionOnClick}/>}
                {permissions[user_type].googleDrive && <AppLink link={hasGoogleAccount ? S360_urls.DRIVE_URL : undefined} target='_blank' title='Drive'
                                                                imageSrc={EXTERNAL_icons.DRIVE} onClick={provisionOnClick}/>}
                {permissions[user_type].googleCalendar && <AppLink link={hasGoogleAccount ? S360_urls.CALENDAR_URL : undefined} target='_blank' title='Calendar'
                                                                   imageSrc={EXTERNAL_icons.CALENDAR} onClick={provisionOnClick}/>}
                {permissions[user_type].eSchools && <ESchoolsDashboardLink school_id={school_id}/>}
                {permissions[user_type].onlineSafety && <AppLink link={hasGoogleAccount ? S360_urls.ONLINE_SAFETY_URL : undefined} target='_blank' title='Online Safety'
                                                                 imageSrc={EXTERNAL_icons.ONLINE_SAFETY} onClick={provisionOnClick}/>}
                {permissions[user_type].discuss && <AppLink link={hasGoogleAccount ? S360_urls.DISCUSS : undefined} target='_blank' title='Discuss'
                                                            imageSrc={EXTERNAL_icons.DISCUSS} height={'67px'} width={'67px'} onClick={provisionOnClick}/>}
                {permissions[user_type].sites && <AppLink link={hasGoogleAccount ? S360_urls.SITES : undefined} target='_blank' title='Sites'
                                                          imageSrc={EXTERNAL_icons.SITES} height={'67px'} width={'67px'} onClick={provisionOnClick}/>}
                {permissions[user_type].notes && <AppLink link={hasGoogleAccount ? S360_urls.NOTES : undefined} target='_blank' title='Notes'
                                                          imageSrc={EXTERNAL_icons.NOTES} height={'67px'} width={'67px'} onClick={provisionOnClick}/>}
            </div>
            {renderModalGoogleAccountProvision()}
            {renderModalGenericMessage()}
        </>
    )

}

export default AdminGoogleLinks;